import {showMessage} from 'exsportia-components'

import {isCachedOpnChargeDegraded} from '../../../api/provider-status/get-provider-status.query'
import {l} from '../../../utils/i18n'

/** A saved-card charge failed while Opn's charge op is DEGRADED: add the retry hint. */
export const showChargeRetryHintIfDegraded = (venueId?: string | null): void => {
  if (isCachedOpnChargeDegraded(venueId)) {
    showMessage(l('checkout-charge-retry-hint'), 'error')
  }
}
